import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loading: false,
        user: undefined,
        version: 'Bêta 1.9',
        menu: true,
        console: true,
        stats : { remplacements : 0, qsp: 0}
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        }, 
        setUser(state, user) {
            state.user = user;
        },
        setConsole(state, console){
            state.console = console;
        },
        setVersionserver(state, versionserver) {
            state.versionserver = versionserver;
        },
        setStats(state, stats) {
            state.stats = stats;
        },
        toggleMenu(state, menu){
            state.menu = menu;
        }
    },
    actions: {
        async updateStats(context){
            context.commit("setStats", (await api.getStats()).data);
        }
    }
})
